import { FlowParameterEventFieldsFragment } from '~/graphql/types';
import { AppFundaContactRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';
import { assertNever } from '~/util/assertion';
import cleanedFilename from '~/util/cleanedFilename';

import { PARAMETER_VALUE_TYPE } from '../../../constants';
import emptyFundaContactRequestEventParameterValue from './emptyFundaContactRequestEventParameterValue';

export default (
  eventFundaContactRequestParameter:
    | Extract<
        FlowParameterEventFieldsFragment,
        {
          __typename: 'Flow_Parameter_Event_Contact_App_Funda_ContactRequest_Pointer';
        }
      >
    | null
    | undefined,
): AppFundaContactRequestPointerParameterValue => {
  if (eventFundaContactRequestParameter == null) {
    return emptyFundaContactRequestEventParameterValue();
  }
  switch (eventFundaContactRequestParameter.__typename) {
    case 'Flow_Parameter_Event_Contact_App_Funda_ContactRequest_Pointer':
      return {
        type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_FUNDA_CONTACTREQUEST_POINTER,
        variable: {
          name: eventFundaContactRequestParameter.variable,
          field: eventFundaContactRequestParameter.field
            ? {
                name: eventFundaContactRequestParameter.field,
              }
            : null,
        },
      };
    default:
      return assertNever(
        eventFundaContactRequestParameter.__typename,
        cleanedFilename(__filename),
      );
  }
};
